module.exports = __webpack_public_path__ + "media/images/flags/64/Saint-Helena-80bd56e282762befb3013a303dcba30d.png";